import { ErrorEvent, EventHint } from '@sentry/react'
import { AxiosError } from 'axios'

import {
  isThirdPartyCodeBySentry,
  markEventExceptionsAsHandled,
  tagEvent,
} from './errorEvent'
import { isAxiosErrorWithCode } from './eventHint'

export const beforeSend = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
  if (isAxiosErrorWithCode(hint, AxiosError.ECONNABORTED)) {
    return null
  }

  if (isThirdPartyCodeBySentry(event)) {
    const handledEvent = markEventExceptionsAsHandled(event)
    return tagEvent(handledEvent, { isManuallyProcessedAsThirdParty: true })
  }

  return event
}
